import React, { createContext, ReactNode } from 'react';
import { GlobalToken, Grid, theme } from 'antd';

const { useBreakpoint } = Grid;

export type AppContextValue = {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  xxl?: boolean;
  isMobile?: boolean;
  globalTheme?: GlobalToken;
};

export const AppContext = createContext<AppContextValue>({});

/**
 * Функциональный компонент, который «один раз» вызывает useBreakpoint
 * и передаёт объект screens во все дочерние компоненты через контекст.
 */
interface AppContextProviderProps {
  children: ReactNode;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
  const screens = useBreakpoint(); // { xs: bool, sm: bool, md: bool, ... }
  const isMobile = screens.xs;
  const { token } = theme.useToken();

  return <AppContext.Provider value={{ ...screens, isMobile, globalTheme: token }}>{children}</AppContext.Provider>;
};
